
/**
 * \@docs-private
 * @return {?}
 */
export function getMdFormFieldPlaceholderConflictError(): Error {
  return Error('Placeholder attribute and child element were both specified.');
}
/**
 * \@docs-private
 * @param {?} align
 * @return {?}
 */
export function getMdFormFieldDuplicatedHintError(align: string): Error {
  return Error(`A hint was already declared for 'align="${align}"'.`);
}
/**
 * \@docs-private
 * @return {?}
 */
export function getMdFormFieldMissingControlError(): Error {
  return Error('md-form-field must contain a MdFormFieldControl. ' +
      'Did you forget to add mdInput to the native input or textarea element?');
}
